// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PnMEntityMapper$PorterinFeature from "../entity-mappers/PnMEntityMapper.mjs";
import * as PnMPathsEntityMapper$PorterinFeature from "../entity-mappers/PnMPathsEntityMapper.mjs";
import * as PnMCampaignEntityMapper$PorterinFeature from "./mapper/PnMCampaignEntityMapper.mjs";
import * as PnMShiftingTypeEntityMapper$PorterinFeature from "./mapper/PnMShiftingTypeEntityMapper.mjs";
import * as ResponseHandler$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ResponseHandler.mjs";
import * as PnMCreateOrderInterestEntityMapper$PorterinFeature from "./mapper/PnMCreateOrderInterestEntityMapper.mjs";
import * as PnMShiftReqSubmitBasicDetailsEntityMapper$PorterinFeature from "./mapper/PnMShiftReqSubmitBasicDetailsEntityMapper.mjs";

var execute = PnMShiftingTypeEntityMapper$PorterinFeature.execute;

var PnMValidateGeoregionApiConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PnMValidateGeoregionApiResponseConverter = partial_arg(PnMValidateGeoregionApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$1 = PnMCreateOrderInterestEntityMapper$PorterinFeature.execute;

var PnMCreateOrderInterestApiConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PnMCreateOrderInterestApiResponseConverter = partial_arg$1(PnMCreateOrderInterestApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$2 = PnMShiftReqSubmitBasicDetailsEntityMapper$PorterinFeature.execute;

var PnMShiftReqBasicDetailsApiConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PnMShiftReqBasicDetailsApiResponseConverter = partial_arg$2(PnMShiftReqBasicDetailsApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$3 = PnMEntityMapper$PorterinFeature.execute;

var PnMDataApiConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PnMDataResponseConverter = partial_arg$3(PnMDataApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

function execute$4(param) {
  return /* None */0;
}

var PnMShiftReqLocationDetailsApiConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PnMShiftReqLocationDetailsApiResponseConverter = partial_arg$4(PnMShiftReqLocationDetailsApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$5 = PnMCampaignEntityMapper$PorterinFeature.execute;

var PnMCampaignResponseConverterConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PnMCampaignResponseConverter = partial_arg$5(PnMCampaignResponseConverterConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$6 = PnMPathsEntityMapper$PorterinFeature.execute;

var PathsApiConfig = {
  execute: execute$6
};

var partial_arg$6 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PnMPathsResponseConverter = partial_arg$6(PathsApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$7 = PnMEntityMapper$PorterinFeature.execute;

var CityApiConfig = {
  execute: execute$7
};

var partial_arg$7 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PnMCityResponseConverter = partial_arg$7(CityApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

export {
  PnMValidateGeoregionApiConfig ,
  PnMValidateGeoregionApiResponseConverter ,
  PnMCreateOrderInterestApiConfig ,
  PnMCreateOrderInterestApiResponseConverter ,
  PnMShiftReqBasicDetailsApiConfig ,
  PnMShiftReqBasicDetailsApiResponseConverter ,
  PnMDataApiConfig ,
  PnMDataResponseConverter ,
  PnMShiftReqLocationDetailsApiConfig ,
  PnMShiftReqLocationDetailsApiResponseConverter ,
  PnMCampaignResponseConverterConfig ,
  PnMCampaignResponseConverter ,
  PathsApiConfig ,
  PnMPathsResponseConverter ,
  CityApiConfig ,
  PnMCityResponseConverter ,
}
/* PnMValidateGeoregionApiResponseConverter Not a pure module */
